import i18n from "../../../../i18n.js"
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: "closing_type_label",
      label: i18n.t('config.type_of_closing'),
      sortable: true,
    },
    {
      prop: "closing_date",
      label: i18n.t('config.date_of_closing'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: "interval",
      label: i18n.t('config.interval_of_closing'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: "farm_name",
      label: i18n.t('common_words.farms2'),
      sortable: true,
    },
    {
      prop: "user_name",
      label: i18n.t('common_words.user'),
      sortable: true,
    },
    {
      prop: "module_name",
      label: i18n.t('common_words.module'),
      sortable: true,
    }


  ];

  const Search = { ...Tables.Search };


  return { Table, Search };
};


export default configTable
